// src/pages/ProductDetails.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import './../styles/styles.css';

export default function ProductDetails() {
  const { user, isAuthenticated } = useAuth();
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const { addToCart } = useCart();
  const navigate = useNavigate();
  
  const API_URL = process.env.REACT_APP_API_URL;


  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // ⚡ Appel API vers ton backend qui retourne un produit en JSON
        const token = user.token || localStorage.getItem('token');
        const response = await fetch(`${API_URL}/products/products?id=${productId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
        if (!response.ok) {
          throw new Error("Erreur lors du chargement du produit");
        }
        const data = await response.json();
        setProduct(data);
      } catch (error) {
        console.error("Erreur API:", error);
        setProduct(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  const handleAddToCart = () => {
    if (product) {
      // On ajoute au panier avec le price_id Stripe
      addToCart({
        id: product.stripe_price_id, // ⚡ Utilisation du price_id Stripe
        title: product.name,
        price: product.price,
        description: product.description,
        image: product.image_url,
        quantity: 1,
      });
      navigate('/cart');
    }
  };

  if (loading) {
    return (
      <section className="section-black" style={{ textAlign: 'center' }}>
        <h2>Chargement du produit...</h2>
      </section>
    );
  }

  if (!product) {
    return (
      <section className="section-black" style={{ textAlign: 'center' }}>
        <h2>Produit non trouvé !</h2>
        <p>Retournez à la boutique pour découvrir d'autres enquêtes.</p>
      </section>
    );
  }

  return (
    <div>
      <section className="section-black product-details-header">
        <h1>{product.name}</h1>
      </section>

      <section className="section-cream product-details-content">
        <div className="product-details-container">
          <div className="product-image-container">
            <img src={product.image_url} alt={product.name} />
          </div>
          <div className="product-info-container">
            <h2>{product.name}</h2>
            <p className="product-price">{parseFloat(product.price).toFixed(2)} €</p>
            <p className="product-description">{product.description}</p>
            <button className="cta-button" onClick={handleAddToCart}>
              Ajouter au panier
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
